import { render, staticRenderFns } from "./RegionsBarChart.vue?vue&type=template&id=750f381c&"
import script from "./RegionsBarChart.vue?vue&type=script&lang=js&"
export * from "./RegionsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports